import styled from 'styled-components';

import { ActivityCenterWrapper } from '@xing-com/crate-activity-center-wrapper';
import { Header } from '@xing-com/crate-layout-header';
import { useDeviceInfo } from '@xing-com/crate-xinglet';
import { Section } from '@xing-com/layout-primitives';
import { BottomBar } from '@xing-com/platform-layout-bottom-bar';
import { Footer } from '@xing-com/platform-layout-footer';
import { LoggedoutViewInnerWrappers } from '@xing-com/platform-layout-logged-out';
import { SkipNavigation } from '@xing-com/platform-layout-skip-navigation';
import { xdlColorBackground } from '@xing-com/tokens';
import { useMediaListener, BREAKPOINTS } from '@xing-com/util';

import { HeaderLoggedOutWithLoginLink } from './header-logged-out-with-login-link';

const StyledLayoutWrapper = styled.div`
  background-color: ${xdlColorBackground};
`;

type UnifiedLayoutProps = {
  layout: 'blank-with-footer' | 'xing-containerless' | 'xing' | 'xing-gridless';
  isLoggedInLayout: boolean;
  loginDestination?: string;
  loginTracking?: string;
};

export const UnifiedLayout: React.FC<
  React.PropsWithChildren<UnifiedLayoutProps>
> = ({
  children,
  layout,
  isLoggedInLayout,
  loginDestination,
  loginTracking,
}) => {
  const isBlankLayout = layout === 'blank-with-footer';
  const isContainerlessLayout = layout === 'xing-containerless';
  const isGridless = layout === 'xing-gridless';
  const isHeaderEnabled = !isBlankLayout;

  const breakpoint = useMediaListener();
  const isNotHandheld = breakpoint !== BREAKPOINTS.handheld;
  const isFooterEnabled = !isLoggedInLayout || isNotHandheld;

  const { isWebview } = useDeviceInfo();
  const isBottomBarEnabled = isLoggedInLayout || !isWebview;

  return (
    <>
      {isLoggedInLayout ? null : <ActivityCenterWrapper />}
      <StyledLayoutWrapper data-qa="core-crate-layout-main">
        {isBlankLayout ? null : <SkipNavigation />}
        {isHeaderEnabled ? (
          isLoggedInLayout ? (
            <Header />
          ) : (
            <HeaderLoggedOutWithLoginLink
              loginDestination={loginDestination}
              loginTracking={loginTracking}
            />
          )
        ) : null}
        {isBlankLayout || isContainerlessLayout ? (
          <main id="content">{children}</main>
        ) : isLoggedInLayout ? (
          isGridless ? (
            <Section noBlockPadding>{children}</Section>
          ) : (
            children
          )
        ) : (
          <LoggedoutViewInnerWrappers {...{ children, gridless: isGridless }} />
        )}

        {isFooterEnabled ? <Footer homeLink="/" /> : null}
        {isBottomBarEnabled ? <BottomBar /> : null}
      </StyledLayoutWrapper>
    </>
  );
};
